<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-24 10:24:27
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveApplication\LeaveApplication.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-07 14:53:10
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_admin_leaveApplication_list_title')"
    pad="0"
    @activated="activated"
  >
    <template v-slot:page-main>
      <Taber
        special
        :curTab="curTab"
        @change="(tab) => (curTab = tab)"
        :items="taber"
        @filter="
          (val, tab) => {
            if (tab == 1) {
              filterPageData1 = val;
            } else filterPageData2 = val;
          }
        "
      >
        <!-- 筛选 -->
        <template v-slot:filter-content-1="{ filter }">
          <div v-show="curTab === 'tab-1'">
            <Selections2
              :objects="filterObjects"
              small-chip
              @filter="
                filter();
                toFilter(1, filter);
              "
              @update="
                (prop, value, selected) => {
                  $fliterValue(filterObjects, prop, value, selected);
                }
              "
              @reset="
                (apply) => {
                  $fliterValue(filterObjects, null, null);
                  if (apply) {
                    filter();
                    toFilter(1, filter);
                  }
                }
              "
            />
          </div>
        </template>
        <template v-slot:filter-content-2="{ filter }">
          <div v-show="curTab === 'tab-2'">
            <Selections2
              :objects="filterObjects2"
              small-chip
              @update="
                (prop, value, selected) => {
                  $fliterValue(filterObjects2, prop, value, selected);
                }
              "
              @filter="
                filter();
                toFilter(2, filter);
              "
              @reset="
                (apply) => {
                  $fliterValue(filterObjects2, null, null);
                  if (apply) {
                    filter();
                    toFilter(2, filter);
                  }
                }
              "
            />
          </div>
        </template>
        <template v-slot:content-1>
          <Tabler
            :headers="headers"
            :items="desserts1"
            :showSelect="showSelect"
            :height="$vuetify.breakpoint.height - 335"
            :filter-page-data="filterPageData1"
            :totalCount="totalCount1"
            @change="
              (page, perpage, callback, data) => {
                getList(1, data, page, perpage, callback);
              }
            "
          >
            <template v-slot:item.applicant="{ item }">
              <div style="max-width: 300px">
                <v-list-item dense two-line class="pa-0">
                  <v-list-item-avatar size="36" class="mr-1 my-0">
                    <StaffAvatar
                      size="36"
                      :src="item.staff_avatar"
                      :staff_name="item.preferred_name"
                    />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="table-title text--primary">
                      {{ $getCommonLangValue(item.preferred_name) }}
                      <span class="text--secondary text-caption-xs">
                        {{ item.staff_code }}</span
                      >
                    </v-list-item-title>
                    <v-list-item-subtitle
                      class="table-subtitle text--secondary"
                    >
                      {{ $getCommonLangValue(item.job_post_name) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </template>
            <template v-slot:item.swift_number="{ item }">
              <div class="table-title text--primary">
                {{ item.swift_number }}
              </div>
            </template>
            <template v-slot:item.type="{ item }">
              <div class="table-title text--primary">
                {{ $getCommonLangValue(item.leave_type_name) }}
                <span v-if="Number(item.cancel_flag) == 1"
                  >({{
                    $t("label_essweb_LeaveApplication_list_tag_cancelLabel")
                  }})</span
                >
              </div>
            </template>
            <template v-slot:item.startDate="{ item }">
              <div class="table-title text--primary">
                {{ $getDateTime(item.start_utc_datetime, "YYYY/MM/DD") }}
              </div>
              <div class="table-subtitle text--secondary">
                {{ $getDateTime(item.start_utc_datetime, "HH:mm") }}
              </div>
            </template>
            <template v-slot:item.endDate="{ item }">
              <div class="table-title text--primary">
                {{ $getDateTime(item.end_utc_datetime, "YYYY/MM/DD") }}
              </div>
              <div class="table-subtitle text--secondary">
                {{ $getDateTime(item.end_utc_datetime, "HH:mm") }}
              </div>
            </template>
            <template v-slot:item.unit="{ item }">
              <div class="table-title text--primary">
                {{ $getCommonLangValue(item.unit) }}
              </div>
            </template>
            <template v-slot:item.total="{ item }">
              <div class="table-title text--primary">
                {{ parseFloat(Number(item.total_time)) }}
              </div>
            </template>
            <template v-slot:item.applicationDate="{ item }">
              <div class="table-title text--primary">
                {{ $getDateTime(item.submission_utc_datetime, "YYYY/MM/DD") }}
              </div>
            </template>
            <template v-slot:item.status="{ item }">
              <StatusChip
                :slideColor="item.approval_tint_color"
                :bgColor="item.approval_bg_color"
              >
                <template v-slot:status>
                  {{ $getCommonLangValue(item.status_detail) }}
                </template>
              </StatusChip>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                @click="toView(item.uuid)"
                v-if="hasBtn('view-admin-leave-application-record')"
              >
                <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
              </v-btn>
            </template>
          </Tabler>
        </template>
        <template v-slot:content-2>
          <Tabler
            :headers="headers"
            :items="desserts2"
            :height="$vuetify.breakpoint.height - 335"
            :showSelect="showSelect"
            :filter-page-data="filterPageData2"
            :totalCount="totalCount2"
            @change="
              (page, perpage, callback, data) => {
                getList(2, data, page, perpage, callback);
              }
            "
          >
            <template v-slot:item.applicant="{ item }">
              <div style="max-width: 300px">
                <v-list-item dense two-line class="pa-0">
                  <v-list-item-avatar size="36" class="mr-1 my-0">
                    <StaffAvatar
                      size="36"
                      :src="item.staff_avatar"
                      :staff_name="item.preferred_name"
                    />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="table-title text--primary">
                      {{ $getCommonLangValue(item.preferred_name) }}
                      <span class="text--secondary text-caption-xs">
                        {{ item.staff_code }}</span
                      >
                    </v-list-item-title>
                    <v-list-item-subtitle
                      class="table-subtitle text--secondary"
                    >
                      {{ $getCommonLangValue(item.job_post_name) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </template>
            <template v-slot:item.swift_number="{ item }">
              <div class="table-title text--primary">
                {{ item.swift_number }}
              </div>
            </template>
            <template v-slot:item.type="{ item }">
              <div class="table-title text--primary">
                {{ $getCommonLangValue(item.leave_type_name) }}
                <span v-if="Number(item.cancel_flag) == 1"
                  >({{
                    $t("label_essweb_LeaveApplication_list_tag_cancelLabel")
                  }})</span
                >
              </div>
            </template>
            <template v-slot:item.startDate="{ item }">
              <div class="table-title text--primary">
                {{ $getDateTime(item.start_utc_datetime, "YYYY/MM/DD") }}
              </div>
              <div class="table-subtitle text--secondary">
                {{ $getDateTime(item.start_utc_datetime, "HH:mm") }}
              </div>
            </template>
            <template v-slot:item.endDate="{ item }">
              <div class="table-title text--primary">
                {{ $getDateTime(item.end_utc_datetime, "YYYY/MM/DD") }}
              </div>
              <div class="table-subtitle text--secondary">
                {{ $getDateTime(item.end_utc_datetime, "HH:mm") }}
              </div>
            </template>
            <template v-slot:item.unit="{ item }">
              <div class="table-title text--primary">
                {{ $getCommonLangValue(item.unit) }}
              </div>
            </template>
            <template v-slot:item.total="{ item }">
              <div class="table-title text--primary">
                {{ parseFloat(Number(item.total_time)) }}
              </div>
            </template>
            <template v-slot:item.applicationDate="{ item }">
              <div class="table-title text--primary">
                {{ $getDateTime(item.submission_utc_datetime, "YYYY/MM/DD") }}
              </div>
            </template>
            <template v-slot:item.status="{ item }">
              <StatusChip
                :slideColor="item.approval_tint_color"
                :bgColor="item.approval_bg_color"
              >
                <template v-slot:status>
                  {{ $getCommonLangValue(item.status_detail) }}
                </template>
              </StatusChip>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                @click="toView(item.uuid)"
                v-if="hasBtn('view-admin-leave-application-record')"
              >
                <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
              </v-btn>
            </template>
          </Tabler>
        </template>
      </Taber>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "LeaveApplication",
  computed: {},
  data() {
    return {
      taber: [
        "label_essweb_leaveApplication_list_tab_underReviewLabel",
        "label_essweb_leaveApplication_list_tab_completeLabel",
      ],
      curTab: "tab-1",
      showDelete: false,
      totalCount1: 0,
      totalCount2: 0,
      showSelect: false,
      headers: [
        {
          text: "label_essweb_leaveApplication_form_swiftNumberLabel",
          value: "swift_number",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveApplication_list_applicantLabel",
          value: "applicant",
          align: "start",
          sortable: false,
          filter: (value, search, item) => {
            if (!this.search) return true;
            return (
              item.preferred_name
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1
            );
          },
        },

        {
          text: "label_essweb_leaveApplication_list_leaveType",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveApplication_list_startDateLabel",
          value: "startDate",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveApplication_list_endDateLabel",
          value: "endDate",
          align: "start",
          sortable: false,
        },

        {
          text: "label_essweb_leaveApplication_list_totalLabel",
          value: "total",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveApplication_list_unitLabel",
          value: "unit",
          align: "start",
          mrcSelected: false,
          sortable: false,
        },
        {
          text: "label_essweb_leaveApplication_list_applicantDateLabel",
          value: "applicationDate",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveApplication_list_statusLabel",
          value: "status",
          align: "start",
          sortable: false,
        },

        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts1: [],
      desserts2: [],
      filterPageData1: null,
      filterPageData2: null,
      filterObjects: [
        {
          type: "string",
          sequence: 0,
          name: "swift_number",
          position: "right",
          label: "label_essweb_leaveApplication_form_swiftNumberLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 1,
          position: "right",
          showKey: "preferred_name",
          subKey: "job_post_name",
          name: "applicant",
          multiple: true,
          avatar: true,
          twoLine: true,
          label: "label_essweb_leaveApplication_list_applicantLabel",
          value: [],

          selected: [],
          data: {
            api: "all_staff",
            url_type: "all_staff",
            args: null,
            table: "mrbase_sys_staffs",
            type: "",
            modelKey: "staff_code",
            valueKey: "staff_id",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 2,
          position: "right",
          name: "leave_type",
          multiple: true,
          label: "label_essweb_leaveApplication_list_leaveType",
          value: [],
          selected: [],
          data: {
            api: "ess_leave_type_select",
            url_type: "prompt",
            args: null,
            table: "x",
            type: "",
            modelKey: "view_fields",
            valueKey: "value_field",
            global: false,
          },
        },
        {
          type: "daterange",
          sequence: 3,
          name: "apply_date",
          position: "right",
          label: "label_essweb_leaveApplication_list_applicantDateLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "daterange",
          sequence: 4,
          name: "date",
          position: "right",
          label: "label_essweb_leaveApplication_list_startDateLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 5,
          position: "right",
          statusChip: "approval",
          name: "status",
          multiple: true,
          label: "label_essweb_leaveApplication_list_statusLabel",
          value: [],

          selected: [],
          data: {
            api: "ess_approval_status_detail_select",
            url_type: "prompt",
            args: null,
            table: "x",
            type: "",
            modelKey: "view_fields",
            valueKey: "value_field",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 6,
          position: "right",
          showKey: "dict_label",
          name: "staff_status",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobStatusLabel",
          value: [],
          selected: [],
          data: {
            api: "/dictionary/list-dictionary-byname/",
            url_type: "primary",
            args: { dict_name: "staffStatus" },
            table: "mrbase_sys_dict",
            type: "lang",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
      ],
      filterObjects2: [
        {
          type: "string",
          sequence: 0,
          name: "swift_number",
          position: "right",
          label: "label_essweb_leaveApplication_form_swiftNumberLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 1,
          position: "right",
          showKey: "preferred_name",
          subKey: "job_post_name",
          name: "applicant",
          multiple: true,
          avatar: true,
          twoLine: true,
          label: "label_essweb_leaveApplication_list_applicantLabel",
          value: [],

          selected: [],
          data: {
            api: "all_staff",
            url_type: "all_staff",
            args: null,
            table: "mrbase_sys_staffs",
            type: "",
            modelKey: "staff_code",
            valueKey: "staff_id",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 2,
          position: "right",
          name: "leave_type",
          multiple: true,
          label: "label_essweb_leaveApplication_list_leaveType",
          value: [],
          selected: [],
          data: {
            api: "ess_leave_type_select",
            url_type: "prompt",
            args: null,
            table: "x",
            type: "",
            modelKey: "view_fields",
            valueKey: "value_field",
            global: false,
          },
        },
        {
          type: "daterange",
          sequence: 3,
          name: "apply_date",
          position: "right",
          label: "label_essweb_leaveApplication_list_applicantDateLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "daterange",
          sequence: 4,
          name: "date",
          position: "right",
          label: "label_essweb_leaveApplication_list_startDateLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 5,
          position: "right",
          statusChip: "approval",
          name: "status",
          multiple: true,
          label: "label_essweb_leaveApplication_list_statusLabel",
          value: [],

          selected: [],
          data: {
            api: "ess_approval_status_detail_select",
            url_type: "prompt",
            args: null,
            table: "x",
            type: "",
            modelKey: "view_fields",
            valueKey: "value_field",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 6,
          position: "right",
          showKey: "dict_label",
          name: "staff_status",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobStatusLabel",
          value: [],
          selected: [],
          data: {
            api: "/dictionary/list-dictionary-byname/",
            url_type: "primary",
            args: { dict_name: "staffStatus" },
            table: "mrbase_sys_dict",
            type: "lang",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
      ],
      first: false,
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(1, null, 1, this.$tableSetting.perPageSize, null);
    this.getList(2, null, 1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.$fliterValue(this.filterObjects, null, null);
        this.$fliterValue(this.filterObjects2, null, null);
        // if (this.page !== null) {
        this.desserts1 = [];
        this.desserts2 = [];
        this.curTab = "tab-1";
        this.getList(1, null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        this.getList(2, null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        this.first = true;
      }
      if (refresh == 1) {
        this.curTab = "tab-1";
        if (this.filterPageData1 || this.filterPageData2) {
          let page1 = 1,
            page2 = 1,
            pagesize1 = null,
            pagesize2 = null;
          if (this.filterPageData1 && this.filterPageData1["data"]) {
            page1 = this.filterPageData1["data"]["cpage"]
              ? this.filterPageData1["data"]["cpage"]
              : 1;
            pagesize1 = this.filterPageData1["data"]["pagesize"]
              ? this.filterPageData1["data"]["pagesize"]
              : null;
          }
          if (this.filterPageData2 && this.filterPageData2["data"]) {
            page2 = this.filterPageData2["data"]["cpage"]
              ? this.filterPageData2["data"]["cpage"]
              : 1;
            pagesize2 = this.filterPageData2["data"]["pagesize"]
              ? this.filterPageData2["data"]["pagesize"]
              : null;
          }
          this.toFilter(1, () => {}, page1, pagesize1);
          this.toFilter(2, () => {}, page2, pagesize2);
        } else {
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
          this.toFilter(2, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    toFilter(tab, callback, page, pagesize) {
      const that = this;
      let object = [];
      if (tab == 1) {
        object = this.filterObjects.filter((ele) =>
          Object.prototype.toString.call(ele["value"]).toLowerCase() ===
          "[object array]"
            ? ele["value"].length
            : ele.value !== undefined && ele.value != ""
        );
      } else {
        object = this.filterObjects2.filter((ele) =>
          Object.prototype.toString.call(ele["value"]).toLowerCase() ===
          "[object array]"
            ? ele["value"].length
            : ele.value !== undefined && ele.value != ""
        );
      }

      let data = {
        approval_status: tab,
      };
      object.map((item) => {
        if (item["name"] == "applicant")
          data["applicant_staff_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "apply_date") {
          data["apply_utc_start_datetime"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[0] : ""
          );
          data["apply_utc_end_datetime"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[1] : ""
          );
        }
        if (item["name"] == "date") {
          data["leave_start_date"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[0] : ""
          );
          data["leave_end_date"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[1] : ""
          );
        }
        if (item["name"] == "leave_type") {
          data["leave_type_uuid"] = item.value.join(",");
        }
        if (item["name"] == "swift_number") {
          data["swift_number"] = item.value;
        }
        if (item["name"] == "status") {
          data["status_detail"] = item.value.join(",");
        }
        if (item["name"] == "staff_status")
          data["staff_status"] = item.value ? item.value.join(",") : "";
      });
      if (!page) {
        this.getList(tab, data, 1, this.$tableSetting.perPageSize, callback);
      } else {
        this.getList(
          tab,
          data,
          page ? page : 1,
          pagesize ? pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    toView: function (uuid) {
      this.$toPage(
        "/admin/leave-application/detail/" +
          this.$aesEncrypt(
            JSON.stringify({
              id: uuid,
            })
          )
      );
    },
    getList: function (approval_status, data, page, perpage, callback) {
      const that = this;
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_application_record",
        url: "/leave-application-record/get-list/",
        data: data
          ? data
          : {
              approval_status: approval_status,
              cpage: page,
              pagesize: perpage,
            },
      }).then((res) => {
        if (approval_status == 1) {
          that.desserts1 = res.data;
          that.totalCount1 = res.totalcount;
          callback ? callback(page, perpage, data, approval_status) : null;
        }
        if (approval_status == 2) {
          that.desserts2 = res.data;
          that.totalCount2 = res.totalcount;
          callback ? callback(page, perpage, data, approval_status) : null;
        }
      });
    },
    toDelete: function (uuid) {},
    toEdit: function (uuid) {},
  },
};
</script>
